// @flow

import duplicateEstimateOptional from '../../../Services/duplicateEstimateOptional';
import type { DuplicateEstimateOptionalParams } from '../../../types';

export default (params: DuplicateEstimateOptionalParams) => async (dispatch: Function) => dispatch(duplicateEstimateOptional(params))